import { render, staticRenderFns } from "./ClipComponent.vue?vue&type=template&id=1708390e"
import script from "./ClipComponent.vue?vue&type=script&lang=js"
export * from "./ClipComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports